// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__Dt2GH","emails":"CreateEditClinics_emails__270sp","emailTagLabel":"CreateEditClinics_emailTagLabel__1Bm6O"};